var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIce = function SvgIconIce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-ice-mask0_6138_8185",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-ice-mask0_6138_8185)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M16.06 9H21V7.5h-3.44L21 4.06 19.937 3l-3.439 3.44V3H15v4.94L13.94 9h-1.19V6h-1.5v3h-1.19L9 7.94V3H7.5v3.44L4.06 3 3 4.061 6.439 7.5H3V9h4.939l1.06 1.061v1.189H6v1.5h3v1.19L7.94 15H3v1.5h3.44L3 19.938 4.06 21l3.44-3.44V21H9v-4.94L10.06 15h1.189v3h1.5v-3h1.188L15 16.06V21h1.5v-3.44L19.938 21l1.061-1.061-3.44-3.44H21V15h-4.94L15 13.94v-1.19h3v-1.5h-3v-1.188zm-2.56 4.5h-3v-3h3z"
  }))));
};
export default SvgIconIce;